module.exports = __webpack_public_path__ + "/1baeff323aa538dcaf7a49b1d0a361ba.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/logos/trxade_logo.png
 ** module id = 958
 ** module chunks = 0
 **/